import { createSelector } from 'reselect';

const getReducer = (state) => state.createEditCampaign;

export const campaignIdSelector = createSelector(
  (state) => getReducer(state).campaignId,
  (campaignId) => campaignId
);

export const contextSelector = createSelector(
  (state) => getReducer(state).context,
  (context) => context
);

export const currentStepSelector = createSelector(
  (state) => getReducer(state).currentStep,
  (currentStep) => currentStep
);

export const detailsSelector = createSelector(
  (state) => getReducer(state).details,
  (details) => details
);

export const showSelector = createSelector(
  (state) => getReducer(state).show,
  (show) => show
);

export const savingErrorSelector = createSelector(
  (state) => getReducer(state).savingError,
  (savingError) => savingError
);
